module.exports = __webpack_public_path__ + "static/media/what-bg.7252aba9.png";